module.exports = __webpack_public_path__ + "static/logo-black-5374014f5b9bc95f696e07d18ca82750.png";